export default __webpack_public_path__ + "static/Servicio Col-USA-fdcd70ed03828a8236df52c5d22afe8a.svg";